import RatesTab from './RatesTab'
export default RatesTab


// WEBPACK FOOTER //
// ./src/components/ChannelTabs/BookingTab/MappingTabs/RatesTab/index.js